module.exports = __webpack_public_path__ + "static/media/undraw_experience_design_eq3j.1eb9e540.svg";